import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { plani8Reducer } from './reducers';
import { plani8Effects } from './effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(plani8Reducer),
    EffectsModule.forRoot(plani8Effects),
    StoreDevtoolsModule.instrument({ maxAge: 10 }),
  ],
  providers: [],
})
export class ReduxStoreModule {}
